import React from "react";
import { graphql } from "gatsby";
import { Helmet } from "react-helmet";

import { MDXRenderer } from "gatsby-plugin-mdx";
import { MDXProvider } from "@mdx-js/react";
import { getImage, GatsbyImage } from "gatsby-plugin-image";

// import KdpBanner from "../components/banner"
import KdpHeader from "../components/headers/headerGeo";
import KdpFooter from "../components/footers/footerv2";
import KdpAriane from "../components/ariane";
import SidebarGeo from "../components/sidebars/sidebarGeo";

import Youtube from "../components/shortcodes/youtube";
import Image from "../components/shortcodes/image";
import Cta from "../components/shortcodes/cta";
import CtaDevis from "../components/shortcodes/CtaDevis";
import CtaIntervention from "../components/shortcodes/CtaIntervention";

import SideForm from "../components/contacts/sidebarForm";

/*
Usage
<Youtube id="" />
<Image src="" alt="" />
<Cta />
*/
const shortcodes = { Youtube, Image, Cta, CtaDevis, CtaIntervention };

const MdxPage = ({
  data: {
    mdx: {
      frontmatter: {
        date,
        slug,
        title,
        title_meta,
        description_meta,
        excerpt,
        thumbnailText,
        thumbnail,
        fil_ariane,
      },
      body,
    },
  },
}) => {
  const moyen = "Formulaire blicko Geo";

  return (
    <div className="bg-white">
      <Helmet>
        <title>{title_meta}</title>
        <meta name="description" content={description_meta} />
        <link rel="canonical" href={"https://www.blicko.fr" + slug} />
      </Helmet>
      <header className="sticky top-0 z-50">
        {/* <KdpBanner /> */}
        <KdpHeader />
        <KdpAriane fil_ariane={fil_ariane} />
      </header>

      <div class="relative mx-auto max-w-7xl h-full lg:flex">
        <main className="">
          <div class="flex overflow-hidden flex-1">
            <div class="flex flex-col flex-1">
              <div class="flex overflow-y-auto flex-1 bg-white paragraph">
                <div className="overflow-hidden relative py-8 bg-white">
                  <div className="relative px-4 sm:px-6 lg:px-8">
                    <div className="mx-auto max-w-prose text-lg">
                      <h1>
                        <span className="block mt-2 text-3xl font-extrabold tracking-tight leading-8 text-center text-gray-900 sm:text-4xl">
                          {title}
                        </span>
                      </h1>

                      <figure className="pt-8">
                        <GatsbyImage
                          className="rounded-lg shadow-lg"
                          alt={thumbnailText}
                          image={getImage(thumbnail)}
                        />
                      </figure>

                      <div className="flex flex-col flex-grow py-4 px-4 mt-12 text-center rounded-lg sm:py-8 sm:px-6 lg:hidden lg:px-8 bg-[#3333e6]">
                        <h2 className="font-extrabold text-white sm:text-2xl text-1xl">
                          <span className="block">
                            Plomberie sanitaire ou chauffage
                          </span>
                        </h2>
                        <p className="mt-4 leading-6 text-blue-200 text-m">
                          Trouvez facilement un plombier de confiance.
                          Réactivité, qualité et efficacité garanties.
                        </p>
                        <a
                          href="#sideform"
                          className="inline-flex justify-center items-center py-3 px-5 mt-8 w-full text-base font-medium text-white bg-orange-600 rounded-md border border-transparent sm:w-auto hover:bg-orange-700"
                        >
                          Demandez un dépannage
                        </a>
                        <p className="py-2 mt-4 text-xl leading-6 text-white lg:hidden">
                          <a href="tel:0428295269">
                            <span className="font-bold">04 28 29 52 69</span>
                          </a>
                        </p>
                      </div>
                    </div>

                    <div className="mx-auto mt-6 text-gray-500 prose prose-blue prose-lg">
                      <MDXProvider components={shortcodes}>
                        <MDXRenderer className="mx-auto mt-6 text-gray-500 prose prose-sky prose-lg">
                          {body}
                        </MDXRenderer>
                      </MDXProvider>
                    </div>

                    <div className="flex flex-col flex-grow py-4 px-4 mt-12 text-center rounded-lg sm:py-8 sm:px-6 lg:px-8 bg-[#3333e6]">
                      <h2 className="font-extrabold text-white sm:text-2xl text-1xl">
                        <span className="block">
                          Plomberie sanitaire ou chauffage
                        </span>
                      </h2>
                      <p className="mt-4 leading-6 text-blue-200 text-m">
                        Trouvez facilement un plombier de confiance. Réactivité,
                        qualité et efficacité garanties.
                      </p>
                      <a
                        href="#sideform"
                        className="inline-flex justify-center items-center py-3 px-5 mt-8 w-full text-base font-medium text-white bg-orange-600 rounded-md border border-transparent sm:w-auto hover:bg-orange-700"
                      >
                        Demandez un dépannage
                      </a>
                      <p className="py-2 mt-4 text-xl leading-6 text-white lg:hidden">
                        <a href="tel:0428295269">
                          <span className="font-bold">04 28 29 52 69</span>
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>

        <aside class="top-32 col-span-1 self-start p-4 lg:order-last lg:py-16 lg:w-1/3">
          <SideForm moyen={moyen} />

          <SidebarGeo />
        </aside>
      </div>

      <footer>
        <KdpFooter />
      </footer>
    </div>
  );
};

export const query = graphql`
  query ($slug: String!) {
    mdx(frontmatter: { slug: { eq: $slug } }) {
      frontmatter {
        date
        slug
        fil_ariane
        title
        title_meta
        description_meta
        excerpt
        thumbnailText
        thumbnail {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
      }
      body
    }
  }
`;

export default MdxPage;

/*

export default function pageTemplate({
  data, // this prop will be injected by the GraphQL query below.
}) {
  let post = data.markdownRemark
  let featuredImgFluid = post.frontmatter.thumbnail.childImageSharp.fluid

  const { markdownRemark } = data // data.markdownRemark holds our post data
  const { frontmatter, html } = markdownRemark

  return (
    <div className="bg-white">
        <Helmet>
          <title>{frontmatter.title_meta}</title>
          <meta name="description" content={frontmatter.description_meta} />
        </Helmet>
        <header className="sticky top-0 z-50">
            <KdpBanner />
            <KdpHeader />
            <KdpAriane fil_ariane={frontmatter.fil_ariane} />
        </header>

        <div class="relative mx-auto max-w-7xl h-full lg:flex">
          
          <aside class="top-32 col-span-1 self-start p-4 lg:sticky lg:order-last lg:py-8 lg:w-1/3">
            <SidebarGeo />
          </aside>

          <main className="">
            <div class="flex overflow-hidden flex-1">
              <div class="flex flex-col flex-1">
                <div class="flex overflow-y-auto flex-1 bg-white paragraph">
                  <div className="overflow-hidden relative py-8 bg-white">
                    <div className="relative px-4 sm:px-6 lg:px-8">
                      <div className="mx-auto max-w-prose text-lg">
                        <h1>
                          <span className="block mt-2 text-3xl font-extrabold tracking-tight leading-8 text-center text-gray-900 sm:text-4xl">
                            {frontmatter.title}
                          </span>
                        </h1>
                        <figure className="pt-8">
                          <Img fluid={featuredImgFluid}
                            className="w-full rounded-lg"
                            alt={frontmatter.thumbnailText}
                          />
                        </figure>
                      </div>

                      <div 
                        className="mx-auto mt-6 text-gray-500 prose prose-blue prose-lg"
                        dangerouslySetInnerHTML={{ __html: html }}
                      />

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>

          

        </div>
        <footer>
          <KdpFooter />
        </footer>
    </div>
  )
}

export const pageQuery = graphql`
  query($slug: String!) {
    markdownRemark(frontmatter: { slug: { eq: $slug } }) {
      html
      frontmatter {
        reference
        date(formatString: "MMMM DD, YYYY")
        slug
        title
        title_meta
        description_meta
        excerpt
        fil_ariane
        thumbnail {
          childImageSharp {
            fluid(maxWidth: 800) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        thumbnailText
      }
    }
  }
`

*/
